export const PageType = {
  CHECKOUT: 'checkout',
  UPSELL: 'upsell',
  CONFIRMATION: 'confirmation',
  OTHER: 'other',
};
